import {Biscuit} from "../../../../utils";
import {Dropdown, DropdownButton, moment} from "../../../../../vendor";
import t from "../../../helpers/t";
import {Div2, Span} from "../styled_components/divs";
import AvailIcon from "../components/AvailIcon";
import Akkus from "../components/Akkus";
import {rbac} from "../index";
import React, { useState } from "react";
import ImageViewer from "../../../components/imgView/ImageView";

const ItemWeb = (props) => {
    const {
        localResource,
        openChangeLog,
        hasResourceNbr,
        showContingentLocationName,
        location_id_name,
        diffString,
        setInitialized,
        switchLock,
        sendSignalSound,
        toggleTheft,
        countOfIcons,
        iconStyle,
        lockPending,
        lockSignalPending,
        lockTheftPending,
        resourcePending,
        onChangeStatus,
        currentUrl,
        onRemoveResource,
        onGetQRCodeHandler,
        act2,
        note,
        link,
        index,
        facilityName
    } = props;
    const [currentImage, setCurrentImage] = useState("")

    function returnBlob (blob) {
        setCurrentImage(URL.createObjectURL(blob))
    }

    return (
        <>
            <div className={"inb-c-item inb-c-item--resource row hide-for-small-only hide-for-medium-only" + (localResource.status === 'active' ? ' not-marked' : (localResource.status === 'inactive' ? ' gray-marked' : ' red-marked'))}  key={"web_div_row_"+localResource.id+"_standard"}>

               {/* {Biscuit.get('user.is_superuser')  === 'true' &&  <aside className="inb-c-item__actions">
                    <DropdownButton id="dropdown-basic-button" title="..." drop="right" menuAlign="right"
                                    bsPrefix="button round inb-toggle-contingent-dd hover">
                        <ul className="inb-dropdown__list">
                            <li data-inb-action-link='changelog' id="kln_changelog">
                                <Dropdown.Item href='#' onClick={() => openChangeLog(localResource.changeLogs)}>
                                    <i className="fi fi-wrench"> </i>
                                    {t('changelog', null, 'capital')}
                                </Dropdown.Item>
                            </li>
                        </ul>
                    </DropdownButton>


                </aside>}*/}
                <div className="large-1 medium-1 small-2 column inb-order-big padding-1" id="order-id" key={"web_div_resource_id_"+localResource.id}>
                    <Span title={hasResourceNbr?t("external_resource_id_short"):"ID"} >
                        {hasResourceNbr?localResource.resource_nbr:localResource.id}
                    </Span><br/>
                    <div title={"ID"} style={{textAlign:'left',paddingTop:"5px"}}>{act2}</div>
                </div>
                <div className="large-2 medium-3 small-6 column inb-order-big" id="name-bike" key={"div_resource_name_"+localResource.id}>
                    <span title={localResource.name} className="text-nowrap">{localResource.name}</span><br/>
                    <div title={note} style={{textAlign:'left',fontSize: ".8125rem", fontWeight: "normal"}}>{note}</div>
                </div>
                <div className="large-1 medium-3 small-6 column" id="inb-contingent" title={localResource.contingent_id_name + (showContingentLocationName ? " | " + localResource.contingent_id_location_name : "")} key={"div_resource_contingent_"+localResource.id}>{localResource.contingent_id_name}{showContingentLocationName ? " | " + localResource.contingent_id_location_name : ""}</div>
                <div className="large-2 medium-3 small-6 column" title={location_id_name} style={{minHeight: "40px"}} key={"div_resource_location_"+localResource.id}>
                    <span className="text-nowrap" style={ localResource.location_id == null || localResource.checkedInStatus === "inprogress" ? {color: "#e54f17"}:{}}>{location_id_name}</span><br />
                    <span className="text-nowrap">{link}</span><br/>
                    <span className="text-nowrap">{facilityName}</span>

                </div>
                <div className="large-1 medium-1 small-1 medium-offset-0 column" id="">
                    <div title="Verfügbarkeit" id="availCheckedIn">
                        <AvailIcon
                            Value={diffString !== null?'pending':localResource.checkedInStatus}
                            Title={diffString !== null?diffString:t(localResource.checkedInStatus,null,'capital')}
                            Reservation={localResource.checkedInStatus === "inprogress" || diffString !== null ? localResource?.reservation?.id : null}
                            key={"web_icon_resource_avail_"+localResource.id}
                            Resource={localResource.id}
                            setInitialized={setInitialized}
                        /> <Div2> {localResource.checkInAmount}</Div2>
                    </div>
                </div>
                <div className="large-2 medium-3 small-1 medium-offset-0 column" id="">
                    <div className="medium-12 small-3 medium-offset-0 column" id="group-icon-three" title="Akkus">
                        <Akkus
                            resource={localResource}
                            switchLock={switchLock}
                            sendSignalSound={sendSignalSound}
                            toggleTheft={toggleTheft}
                            showPercent={true}
                            countOfIcons={countOfIcons}
                            style={iconStyle}
                            mobile={false}
                            key={"web_akkus_"+localResource.id}
                            lockPending={lockPending}
                            lockSignalPending={lockSignalPending}
                            lockTheftPending={lockTheftPending}
                            locked={lockPending !== null && lockPending?.id === localResource.id}/>
                    </div>
                </div>

                <div className="large-1 medium-3 small-4 medium-offset-0 column padding-05" title="Status" key={"web_div_resource_status_"+localResource.id}>
                    {rbac.hasPermission('editStatus') &&
                        <>{resourcePending === null ? <select
                            className={index % 2 === 1 ? 'inbooma-select-box__input second-select' : 'inbooma-select-box__input'}
                            name="status"
                            onChange={e => onChangeStatus(e, localResource)}
                            key={"web_select_resource_status_"+localResource.id}
                            value={localResource.status === null ? '' : localResource.status}
                            placeholder={t('select_${a}', {a: t('status')})}>
                            {['active', 'inactive', 'defect'].map(status => {
                                return (
                                    <>
                                        <option key={'web_'+status+localResource.id} value={status}>{t(status)}</option>
                                    </>
                                )
                            })}
                        </select>:<> <span><img alt="RollingLoader" className="rollingLoader colorize-black" src={"assets/img/rolling_loader.svg"} /> </span></>}</>
                    }
                    {!rbac.hasPermission('editStatus') &&
                        <span>{t(localResource.status)}</span>
                    }
                </div>
                <div className="large-1 medium-3 small-1 medium-offset-0 column datetime-booking text-nowrap" title="Modifiziert am" key={"web_div_resource_modified_"+localResource.id}>{ moment(localResource.modified).format('DD.MM.YY HH:mm')}</div>

                <div className="large-1 medium-3 small-6 medium-offset-0 column item-button-group" key={"div_resource_edit_"+localResource.id}>
                    {rbac.hasPermission('editResource') &&
                        <div className="button-container-resources" key={"div_resource_button_container_edit_"+localResource.id}>
                            <a
                                href={"/resources/"+localResource.id + currentUrl.search}
                                title={t('edit')}
                                key={"web_a_resource_edit_"+localResource.id}
                                data-inb-action-link="edit">
                                <button type="button" className="inb-round-btn hollow round float-left" key={"web_a_button_resource_edit_"+localResource.id} style={{width:"34px",height:"34px"}}

                                >
                                    <div className="inb-fi-edit" style={{marginLeft:"-3px"}}> </div>
                                </button>
                            </a>
                        </div>
                    }
                    {rbac.hasPermission('write') &&
                        <div className="button-container-resources"  key={"div_resource_button_container_delete_"+localResource.id}>
                            <a
                                href="#"
                                className="inb-reservation__pdf2"
                                title={t('delete')}
                                key={"a_resource_delete_"+localResource.id}
                                data-inb-action-link="delete">
                                <button type="button" className="inb-round-btn hollow round float-left"
                                        key={"web_a_button_resource_delete_"+localResource.id}
                                        onClick={() => onRemoveResource(localResource)} style={{width:"34px",height:"34px"}}>
                                    <div className="inb-fi-remove" style={{marginLeft:"-3px"}}> </div>
                                </button>
                            </a>
                        </div>
                    }
                    <div className="button-container-resources"  key={"div_resource_button_container_qr_"+localResource.id}>
                        <a
                            href="#"
                            title={t('getQRCode')}
                            key={"a_resource_qr_"+localResource.id}
                            data-inb-action-link="delete">
                            <button type="button" className="inb-round-btn hollow round float-left"
                                    key={"web_a_button_resource_qr_"+localResource.id}
                                    onClick={() => setCurrentImage(onGetQRCodeHandler(localResource, returnBlob))} style={{width:"34px",height:"34px"}}>
                                <div className="inb-fi-qrcode" style={{marginLeft:"-3px"}}> </div>
                            </button>
                        </a>
                    </div>
                </div>

            </div>
            {currentImage && (
            <ImageViewer
             images={localResource}
             currentImage={currentImage}
             setCurrentImage={setCurrentImage}
        />)}
        </>
    )
}

export default ItemWeb;